import styled from "styled-components";
import { headerCommonStyle } from "./common.js";

export const H2 = styled.h2`
  ${headerCommonStyle}
  font-size: ${({ theme }) => theme.fontSize.xl2};
`;
